<div #subNavbarContainer>
  <sub-navbar></sub-navbar>
</div>
<div
  [ngClass]="{ 'with-banner': details.headerImageUrl }"
  class="cms-item-view flex flex-col flex-start-stretch flex-full"
>
  <layout-container [mode]="LayoutContainerModes.fullWidth">
    <div class="cms-item-view-container flex flex-col flex-full">
      @if (details.headerImageUrl) {
        <div
          [ngStyle]="{ 'background-image': 'url(' + details.headerImageUrl + ')' }"
          class="cms-item-view-header flex flex-start-stretch flex-auto"
        ></div>
      }
      <div class="cms-item-view-content flex flex-col flex-[0_1_100%]">
        <mat-card appearance="outlined" class="gradient-box-shadow flex flex-col flex-initial">
          <mat-card-title>
            @if (hasTags) {
              <div class="cms-item-view-tags-container" data-test-id="cms-item-view-tags-container">
                @for (tag of details.tags; track tag; let i = $index) {
                  <div [attr.color]="'accent'" [attr.data-test-id]="'cms-item-view-tag-' + i" class="tag pill">
                    {{ tag }}
                  </div>
                }
              </div>
            }
            @if (details.title) {
              <h2 class="news-title max-md:hidden">{{ details.title }}</h2>
              <h3 class="news-title md:hidden">{{ details.title }}</h3>
            }
          </mat-card-title>
          <mat-card-content>
            <ng-content></ng-content>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </layout-container>
</div>
